import Character from "../mechanics/characters/Character";
import { Item } from "../mechanics/items/Item";

export const upgradeItem = (item: Item, character: Character) => {
    const itemCurrensyNeed = item.getItemLvl().itemToLvlUpAmount
    const itemCurrensyName = item.getItemLvl().itemToLvlUpName
    const characterCurrensy = character.getInventory().getCurrensies()
    const characterRightCurrensy = characterCurrensy[itemCurrensyName].amount

    if (characterRightCurrensy < itemCurrensyNeed) return

    item.setItemLvl()

    characterCurrensy[itemCurrensyName] = {
        ...characterCurrensy[itemCurrensyName],
        amount: characterRightCurrensy - itemCurrensyNeed
    }
}